import { useState, useEffect } from "react";
import { toast } from "sonner";
import { http, auDateTime } from "../../../portal/api";

export default function AuditTab({ engagementId }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    http.get(`/portal/admin/engagements/${engagementId}/audit`)
      .then(({ data }) => setRows(data))
      .catch(() => toast.error("Could not load audit log."));
  }, [engagementId]);

  if (rows === null) return <p className="font-mono text-xs uppercase tracking-[0.3em] text-stone2">Loading…</p>;
  if (rows.length === 0) return <p className="text-sm text-stone2 border border-line bg-surface1 p-8" data-testid="audit-empty">No audit events yet.</p>;

  return (
    <div className="space-y-px bg-line/40 border border-line/40" data-testid="audit-log">
      {rows.map((r, i) => (
        <div key={r.id} data-testid={`audit-row-${i}`} className="bg-ink p-4 flex flex-wrap items-baseline gap-x-4 gap-y-1">
          <time className="font-mono text-[10px] text-stone2 w-36">{auDateTime(r.created_at)}</time>
          <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-ember">{r.action}</span>
          <span className="font-mono text-[11px] text-stone2">{r.actor_email} ({r.actor_role})</span>
          {r.target_type && <span className="font-mono text-[10px] px-2 py-0.5 border border-line text-stone2">{r.target_type}</span>}
          {r.detail && <span className="text-sm text-stone2">{r.detail}</span>}
          {r.ip && <span className="font-mono text-[10px] text-stone2 ml-auto">{r.ip}</span>}
        </div>
      ))}
    </div>
  );
}
